export default "__VITE_ASSET__CkiqOKY6__"